import { isDefined } from './object';
import { DTO_FORCE_CONSTRUCTOR } from '@core/utils/dto';

export function isDeprecatedSerialisable(entity: any) {
    return isDefined(entity['fromJson']) || isDefined(entity['toJson']);
}

export function isSerializable(entity: any) {
    return isDefined(entity['import']) && isDefined(new entity()['export']);
}

export function isForceConstructor(entity: any) {
    return isDefined(entity.prototype[DTO_FORCE_CONSTRUCTOR]);
}
